import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import { SessionService } from 'app/components/common/session/session.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogueUserService {

  constructor(private http: HttpClient, private sessionService: SessionService, private catalogueService: CatalogueService) { }


  changeLanguage(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE_USER.CHANGE_LANGUAGE + '/' + dataIn.catalogueUserId + '/changeLanguage';
    let dataInPut = { 'language': dataIn.language };

    return this.http.put(url, dataInPut);

  }


  changePassword(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE_USER.CHANGE_PASSWORD;

    return this.http.post(url, dataIn);

  }


  getExhibitorsByCatalogueUserId(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE_USER.GET_EXHIBITORS_BY_CATALOGUE_USER_ID + '?id=' + dataIn.catalogueUserId + '&eventName=' + dataIn.eventName;

    return this.http.get(url);

  }



  setData(data) {
    let nameStorage = `catalogueUser_${this.catalogueService.getProperty('sapCode')}`;
    this.sessionService.set(nameStorage, data, true);
  }

  getData() {
    let nameStorage = `catalogueUser_${this.catalogueService.getProperty('sapCode')}`;
    return JSON.parse(this.sessionService.get(nameStorage, true) || '{}');
  }

  getProperty(property) {
    return this.getData()[property] || null;
  }


  getTokenForgotPassword(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE_USER.GET_TOKEN_FORGOT_PASSWORD;

    return this.http.post(url, dataIn);

  }




}
